import {
    PAYMENTS_LIST_GET_PAYMENTS,
    PAYMENTS_LIST_GET_PAYMENTS_RESULT,
    CLEAR_REDUX,
} from 'config/redux/actionTypes';

//STATE INITIAL
const INIT_STATE = {
    loading: false,
    error: false,
    data: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case PAYMENTS_LIST_GET_PAYMENTS:
            return { ...state, loading: true, data: null, error: false };

        case PAYMENTS_LIST_GET_PAYMENTS_RESULT:
            return { ...state, loading: false, error: action?.payload?.error || false, data: action?.payload?.response };

        case CLEAR_REDUX:
            return ["", "PAYMENTS_LIST"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : state

        default:
            return state;
    }
};
